import React from 'react';
import { ContextMenuColumnItems } from "../ContextMenuColumnItems/ContextMenuColumnItems.js";
import { InlineLabel } from "../InlineLabel/InlineLabel.js";
import styles from "./InlineFolder.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function InlineFolder({
  label,
  ...props
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inlineFolder,
    style: {
      '--entry-indentation-multiplicator': props.level
    },
    children: [/*#__PURE__*/_jsx(InlineLabel, {
      className: styles.label,
      children: label
    }), /*#__PURE__*/_jsx(ContextMenuColumnItems, {
      ...props
    })]
  });
}